import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon div-icon"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text margin-10 width100" }
const _hoisted_4 = { class: "display-flex justify-content-space-between heading margin-bottom-5" }
const _hoisted_5 = {
  key: 0,
  for: "EventVisibility",
  class: "lbl-card no-margin cursor-pointer bold-text"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "checked div-checked-circle" }
const _hoisted_10 = { class: "fa fa-check-circle color-green" }
const _hoisted_11 = { class: "position-relative display-flex align-items-baseline" }
const _hoisted_12 = ["src", "title"]
const _hoisted_13 = ["disabled", "checked"]
const _hoisted_14 = { class: "checked position-relative" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "checked position-relative" }
const _hoisted_17 = {
  for: "enabled",
  class: "position-enabled"
}
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = ["disabled", "checked"]
const _hoisted_20 = {
  key: 0,
  class: "small-description margin-bottom-5"
}
const _hoisted_21 = ["value"]
const _hoisted_22 = ["src", "title"]
const _hoisted_23 = {
  key: 1,
  class: "small-description margin-bottom-5"
}
const _hoisted_24 = {
  key: 0,
  class: "read-more"
}
const _hoisted_25 = ["href"]
const _hoisted_26 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "cardContainer",
    class: _normalizeClass(["card-option div-card position-relative", {
      'card-option-selected': _ctx.localCard.IsSelected,
      disable: _ctx.localCard.IsDisabled,
      'display-none': !_ctx.localCard.IsVisible
    }]),
    onMouseover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getReadMore(true))),
    onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getReadMore(false)))
  }, [
    _createElementVNode("div", {
      class: "display-flex",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectItem(_ctx.localCard)))
    }, [
      (!_ctx.isHideTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.localCard.IconUrl,
              alt: "Warning"
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            (!_ctx.isHideTitle)
              ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.localCard.Title) + " ", 1),
                  (!_ctx.isHideInformationString)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        ref: "infoIcon",
                        class: "fa fa-info-circle",
                        "aria-hidden": "true",
                        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GetInformationString(true))),
                        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.GetInformationString(false)))
                      }, null, 544))
                    : _createCommentVNode("", true),
                  (_ctx.isMounted && _ctx.TeleportTargetExists())
                    ? (_openBlock(), _createBlock(_Teleport, {
                        key: 1,
                        to: _ctx.cardVisibilityElementId
                      }, [
                        (_ctx.ShowInformationTooltip())
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "information-icon-div",
                              style: _normalizeStyle({left: _ctx.tooltipStyle})
                            }, _toDisplayString(_ctx.localCard.InformationString), 5))
                          : _createCommentVNode("", true)
                      ], 8, ["to"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.localCard.IconUrl,
                  class: "logo"
                }, null, 8, _hoisted_6))
          ]),
          (_ctx.localCard.ControlType === 4 && _ctx.localCard.IsSelected)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("img", {
                  src: _ctx.GetIconImage(),
                  class: "margin-right-10"
                }, null, 8, _hoisted_7),
                _createElementVNode("label", {
                  class: _normalizeClass(["no-margin font-weight-500 valign", [_ctx.IsInputBoxVisible() && _ctx.isCallbackReturned ? 'successfully-configured' : (_ctx.IsInputBoxVisible() ? 'warning-message' : 'not-configured') ]])
                }, _toDisplayString(_ctx.localCard.Message), 3),
                (!_ctx.IsInputBoxVisible())
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "not-configured font-weight-600 valign",
                      href: _ctx.localCard.ReadMoreLink,
                      target: "_blank",
                      rel: "noreferrer"
                    }, _toDisplayString(_ctx.$t('EventVisibility.ReadMore')), 9, _hoisted_8))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("i", _hoisted_10, null, 512), [
              [_vShow, _ctx.localCard.IsSelected]
            ])
          ], 512), [
            [_vShow, _ctx.localCard.ControlType === 0]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            (_ctx.localCard.QRCodeData ?? false)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.qrCodeIcon,
                  title: _ctx.localCard.QRCodeData!.Tooltip,
                  class: "margin-right-10",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.ShowQRCode()), ["stop"]))
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              type: "checkbox",
              name: "featureCheckBox",
              class: "checked-position cursor-pointer",
              disabled: _ctx.localCard.IsDisabled,
              checked: _ctx.localCard.IsSelected && !_ctx.localCard.IsDisabled
            }, null, 8, _hoisted_13)
          ], 512), [
            [_vShow, _ctx.localCard.ControlType === 1]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              href: _ctx.contactUsToEnableLink,
              target: "_blank",
              rel: "noreferrer",
              class: "hyper-link position-contact-us-to-enabled"
            }, _toDisplayString(_ctx.$t("EventVisibility.ContactUsToEnable")), 9, _hoisted_15)
          ], 512), [
            [_vShow, _ctx.localCard.ControlType === 2]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Enabled")), 1)
          ], 512), [
            [_vShow, _ctx.localCard.ControlType === 3]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_18, [
            _createElementVNode("input", {
              type: "checkbox",
              name: "integrationCheckBox",
              class: "checked-position cursor-pointer",
              disabled: _ctx.localCard.IsDisabled,
              checked: _ctx.localCard.IsSelected && !_ctx.localCard.IsDisabled
            }, null, 8, _hoisted_19)
          ], 512), [
            [_vShow, _ctx.localCard.ControlType === 4]
          ])
        ]),
        (_ctx.IsDesciptionHidden())
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('APIkey')), 1),
              _createElementVNode("div", {
                class: "display-flex",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  readonly: "",
                  value: _ctx.localCard.InputBoxData
                }, null, 8, _hoisted_21),
                _createElementVNode("img", {
                  src: _ctx.copyIcon,
                  class: "margin-left-10",
                  title: _ctx.$t('Dialogue.CopyIcon'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.CopyKeyToClipboard(_ctx.localCard.InputBoxData)))
                }, null, 8, _hoisted_22)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.localCard.Description), 1))
      ])
    ]),
    (_ctx.isReadMoreVisible && _ctx.localCard.HelpText !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("a", {
            href: _ctx.localCard.HelpTextUrl,
            target: "_blank",
            rel: "noreferrer",
            class: "text-underline margin-right-3"
          }, _toDisplayString(_ctx.localCard.HelpText), 9, _hoisted_25),
          (_ctx.localCard.IsExternalLink)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.readMoreIcon,
                alt: "read more icon"
              }, null, 8, _hoisted_26))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}